import { connect } from 'react-redux'
import PublicRoute from './PublicRoute'

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated
})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicRoute)
